/**
 * Shared helpers for invoice Total / Due on Invoice Details (mirrors BE dealAmounts).
 */

export const INVOICE_SOURCE_DEBIT_NOTE = 'Debit Note';
export const INVOICE_SOURCE_CREDIT_NOTE = 'Credit Note';
export const INVOICE_SOURCE_EXTRA_CHARGE = 'Extra Charge';

export function isActiveInvoice(invoice) {
  return !invoice?.cancelled && invoice?.status !== 'Cancelled';
}

export function isCreditNoteInvoice(invoice) {
  return String(invoice?.source || '').trim() === INVOICE_SOURCE_CREDIT_NOTE;
}

export function isDebitNoteInvoice(invoice) {
  return String(invoice?.source || '').trim() === INVOICE_SOURCE_DEBIT_NOTE;
}

export function invoiceOutstandingContribution(invoice) {
  if (!isActiveInvoice(invoice)) return 0;
  const amount = Number(invoice?.amount || 0);
  const late = Number(invoice?.late_fees || 0);
  const paid = Number(invoice?.paid_amount || 0);
  const paidLate = Number(invoice?.paid_late_fees || 0);
  if (isCreditNoteInvoice(invoice)) {
    return -amount;
  }
  return Math.max(0, amount + late - paid - paidLate);
}

export function invoiceTotalAdjustmentContribution(invoice) {
  if (!isActiveInvoice(invoice)) return 0;
  const amount = Number(invoice?.amount || 0);
  if (isCreditNoteInvoice(invoice)) return -amount;
  const source = String(invoice?.source || '').trim();
  if (source === INVOICE_SOURCE_DEBIT_NOTE || source === INVOICE_SOURCE_EXTRA_CHARGE) {
    return amount;
  }
  return 0;
}

export function computeDealDueFromInvoices(invoices = []) {
  const due = invoices.reduce((sum, inv) => sum + invoiceOutstandingContribution(inv), 0);
  return Math.max(0, Math.round(due));
}

export function computeAdjustedDealTotal(baseTotalPrice, invoices = []) {
  const adjustment = invoices.reduce(
    (sum, inv) => sum + invoiceTotalAdjustmentContribution(inv),
    0
  );
  return Math.max(0, Math.round(Number(baseTotalPrice || 0) + adjustment));
}
